import LoginTypes from './login.types';
import { decodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE = {
	loginResponse: null,
};

const loginReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		case LoginTypes.LOGIN_START:
			return { ...state, loginResponse: null };
		case LoginTypes.LOGIN_SUCCESS:
			return {
				...state,
				loginResponse: decodeHexResponse(action.payload, LoginTypes.LOGIN_KEY),
			};
		case LoginTypes.LOGIN_FAILURE:
			return {
				...state,
				loginResponse: decodeHexResponse(action.payload, LoginTypes.LOGIN_KEY),
			};
		case LoginTypes.LOGIN_RESPONSE_CHANGED:
			return { ...state, loginResponse: null };
		case LoginTypes.LOGIN_RESPONSE_REST_START:
			return { ...state, loginResponse: null };
		case LoginTypes.PERSIST_LOGIN_DATA_START:
			return { ...state, loginResponse: action.payload };
		default:
			return state;
	}
};

export default loginReducer;
